import { FC, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import PerFlexRow from '../../../../components/custom_components/FlexRow'
import MeetingBackground from '../../../../components/custom_components/Meeting/MeetingBackground'
import PerText from '../../../../components/custom_components/Text'
import { updateMeetingNotes } from '../../../../graphql/meeting/hooks/updateMeetingNotes'
import { Meeting, MeetingStepStatus, MeetingStepViewId } from '../../../../types'
import { MeetingStepDefaultProps } from '../shared/appraisal-types'
import { AppraisalFlowHelper } from '../shared/AppraisalFlowHelper'
import AppraisalPageDescription from '../shared/AppraisalPageDescription'
import RichTextBox from '../../../../components/custom_components/RichTextBox'

const AppraisalMeetingStepMeetingNotes: FC<MeetingStepDefaultProps> = ({ meeting, nextBtn, backBtn }) => {
  const [t] = useTranslation()

  const [notes, setNotes] = useState(
    meeting.appraisal && meeting.appraisal.meetingGeneralFeedback ? meeting.appraisal.meetingGeneralFeedback : '',
  )

  const notesRef = useRef<{ meetingId: Meeting['id']; initial: string; updated: string }>({
    meetingId: meeting.id,
    initial: notes,
    updated: notes,
  })

  useEffect(() => {
    const submitNotes = notesRef.current
    return () => {
      if (submitNotes.initial !== submitNotes.updated) {
        updateMeetingNotes(submitNotes.meetingId, submitNotes.updated)
      }
    }
  }, [])

  return (
    <>
      <MeetingBackground>
        <PerText appearance="heading" mb="m" color="primary">
          {t('appraisalMeeting.stepMeetingNotes.pageHeaderMeeting')}
        </PerText>
        <AppraisalPageDescription description={t('appraisalMeeting.stepMeetingNotes.pageDescriptionMeeting')} />
        <RichTextBox
          placeholder={t('appraisalMeeting.stepMeetingNotes.textAreaPlaceHolder')}
          text={notes}
          onChange={(text) => {
            setNotes(text)
            notesRef.current.updated = text
          }}
        />
      </MeetingBackground>
      <PerFlexRow justify="space-between">
        {backBtn && backBtn(MeetingStepStatus.Done)}
        {nextBtn && nextBtn(MeetingStepStatus.Done, false)}
      </PerFlexRow>
      <AppraisalFlowHelper stepViewId={MeetingStepViewId.MeetingNotes} stepStatus={MeetingStepStatus.Done} />
    </>
  )
}

export default AppraisalMeetingStepMeetingNotes
